import { returnErrors } from './errorAction';
import { getApiCall, postApiCall } from '../utils/request';
import {
    GET_FEEDS, GET_NEXT_FEEDS, GET_SKILL_FILTER, SKILL_CLICKED, RESET_FEEDS, GET_FILTERED_FEEDS, GET_SAVED, OPEN_SHARE,
    CLOSE_SHARE, SHARED, GET_RESOURCE_DETAIL, GET_FEED_LIKES, SHOW_FEED, CLOSE_FEED,FEED_ANALYTIC
} from '../actionType/type';




export const getFeeds = (page) => async (dispatch) => {
    try {
        const response = await getApiCall(`user/learn/feed?page=${page}`);
        dispatch({ type: GET_FEEDS, payload: response.data.data });
    } catch (error) {
        returnErrors(dispatch, error.response?.data.message, error.response?.status)
    }
}

export const getNextFeeds = (page, skills, type) => async (dispatch) => {
    try {
        const response = await getApiCall(`user/learn/feed?page=${page}&type=${type !== undefined ? type : []}&skills=${encodeURIComponent(skills ? skills : [])}`);
        dispatch({ type: GET_NEXT_FEEDS, payload: response.data.data });
    } catch (error) {
        returnErrors(dispatch, error.response?.data.message, error.response?.status)
    }
}

export const getSkillfilter = () => async (dispatch) => {
    try {
        const response = await getApiCall(`user/learn/skills?acquired=false`);
        dispatch({ type: GET_SKILL_FILTER, payload: response.data.data });

    } catch (error) {
        returnErrors(dispatch, error.response?.data.message, error.response?.status)
    }
}

export const onClickSkill = (title, value, id) => async (dispatch) => {
    return dispatch({
        type: SKILL_CLICKED, payload: { title, value, id }
    })
}


export const getFilterResult = (page, skills, type) => async (dispatch) => {
    try {
        const response = await getApiCall(`user/learn/feed?page=${page}&type=${type}&skills=${encodeURIComponent(skills)}`);
        dispatch({ type: GET_FILTERED_FEEDS, payload: response.data.data });
    } catch (error) {
        returnErrors(dispatch, error.response?.data.message, error.response?.status)
    }
}

export const resetFeed = () => async (dispatch) => {
    return dispatch({
        type: RESET_FEEDS
    })
}

export const getSaved = (id) => async (dispatch) => {
    return dispatch({
        type: GET_SAVED, payload: id
    })
}

export const shareFeed = (data) => async (dispatch) => {
    return dispatch({
        type: OPEN_SHARE, payload: data
    })
}

export const shareModalClose = () => async (dispatch) => {
    return dispatch({
        type: CLOSE_SHARE
    })
}
export const shareAll = (resource) => async (dispatch) => {
    try {
        const response = await postApiCall('user/share/resource/internal', resource);
        if (response.data.success) {
            dispatch({ type: SHARED, payload: response.data });
            returnErrors(dispatch, `${resource.resource_type} is shared`, 200)
        }

    } catch (error) {
        returnErrors(dispatch, error.response.data.message, error.response.status);
    }
}

export const showFeed = (items) => async (dispatch) => {
    return dispatch({
        type: SHOW_FEED, payload: items
    })
}

export const closeFeed = (items) => async (dispatch) => {
    return dispatch({
        type: CLOSE_FEED
    })
}
export const getResourceData = (contentType, id, type) => async (dispatch) => {
    try {
        const response = await getApiCall(`user/learn/resource?type=${contentType}&_id=${id}`);
        const data = response.data
        dispatch({ type: GET_RESOURCE_DETAIL, payload: data });
    } catch (error) {
        returnErrors(dispatch, error.response?.data.message, error.response?.status)
    }
}

export const likeFeed = (data) => async (dispatch) => {
    let likedId = {
        r_id: data._id,
        type: data.type,
        liked: data.liked
    }
    try {
        const response = await postApiCall('user/learn/resource/like', likedId);
        dispatch({ type: GET_FEED_LIKES, payload: likedId });
    }
    catch (error) {
        returnErrors(dispatch, error.response !== undefined && error.response.data.message, error.response !== undefined && error.response.status);
    }
}

export const sendAnalytic = (analytic) => async (dispatch) => {
    try {
        const response = await postApiCall('user/learn/analytic', analytic);
        dispatch({ type: FEED_ANALYTIC, payload: analytic });

    } catch (error) {
        returnErrors(dispatch, error.response !== undefined && error.response.data.message, error.response !== undefined && error.response.status);
    }
}